import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaShareAlt,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SocialMediaVideoCreationInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Social Media Video Creation in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Online Presence</Subheading>}
        heading={
          <Heading>
            Social Media <span tw="text-primary-500">Video Creation</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in social media video creation in
            **DIFC**, crafting engaging, platform-optimized videos that amplify
            your brand’s reach and drive audience interaction. Go viral with our
            creative and professional video solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-e515679aff46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media video production setup
          "https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Content creator filming
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media creative setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Engaging Social Media Videos in DIFC"
        description="We create videos optimized for social media success."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Platform-Optimized",
            description: "Tailored for Instagram, TikTok, YouTube, and more.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Expertise",
            description: "Trusted by DIFC brands for viral content.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "High Engagement",
            description: "Videos designed to captivate audiences.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround for timely campaigns.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly",
            description: "Optimized for seamless mobile viewing.",
          },
          {
            icon: <FaShareAlt color="#ff5464" size={40} />,
            title: "Viral Potential",
            description: "Content crafted to maximize shares and likes.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Social Media Video Creation Process"
        description={
          <Description>
            We produce high-impact social media videos with a strategic process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your brand and campaign goals.</li>
              <li>Concept Development: Craft trending, engaging ideas.</li>
              <li>
                Filming: Capture with professional, high-quality equipment.
              </li>
              <li>
                Editing: Optimize for platform-specific formats and trends.
              </li>
              <li>Delivery: Provide ready-to-post videos.</li>
              <li>Support: Offer insights for maximizing engagement.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile-first video editing
          "https://images.unsplash.com/photo-1551817958-d9d86fb29431?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional social media setup
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Creative team meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Social Media Video Wins in DIFC"
        description="Our videos have driven engagement in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaigns",
            description: "Boosted reach with trending content.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Growth",
            description: "Increased followers for DIFC brands.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from social media projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Go Viral?</Subheading>}
        heading="Social Media Video Creation in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for social media video creation in DIFC.
            Create engaging, platform-optimized videos that boost your brand’s
            presence—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Smartphone with social media apps
          "https://images.unsplash.com/photo-1572048572929-782ede5ee44b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape for social content
          "https://images.unsplash.com/photo-1533422902779-aff35862e462?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media content creation
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
